/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ranking-footer[_ngcontent-%COMP%]{background-color:var(--ion-color-primary)}.table[_ngcontent-%COMP%]{width:100%;margin:15px 0}"];
export { styles as styles };
